import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import SequencerOperationLog from "models/audioEditor/sequencerOperationLog/SequencerOperationLog";
import RSVP from "rsvp";

const SequencerOperationInsertVideoNodeLog =  SequencerOperationLog.extend({
    idAttribute: "id",


    constructor: function(attributes, options) {
        SequencerOperationLog.apply(this, [attributes, options]);
        
    },

    getOperationName : function(){
        return "Insert Video Node";
    },

    setVideoSequencerNode : function(videoSequencerNode){
        this.set("videoSequencerNode", videoSequencerNode);
    },

    getVideoSequencerNode : function(){
        return this.get("videoSequencerNode");
    },

    setSequencerNodeToInsertNextTo : function(sequencerNodeToInsertNextTo){
        this.set("sequencerNodeToInsertNextTo", sequencerNodeToInsertNextTo);
    },

    getSequencerNodeToInsertNextTo : function(){
        return this.get("sequencerNodeToInsertNextTo");
    },

    setInsertBefore : function(insertBefore){
        this.set("insertBefore", insertBefore);
    },

    getInsertBefore : function(){
        return this.get("insertBefore");
    },



});

export default SequencerOperationInsertVideoNodeLog; 